/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpLeftIcon16Solid = forwardRef('ArrowDRadiusUpLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.116 1.616a1.25 1.25 0 1 1 1.768 1.768L4.518 5.75H8A7.25 7.25 0 0 1 15.25 13a1.25 1.25 0 1 1-2.5 0A4.75 4.75 0 0 0 8 8.25H4.518l2.366 2.366a1.25 1.25 0 0 1-1.768 1.768L1.465 8.732a2.45 2.45 0 0 1 0-3.464l3.651-3.652Z" })));
});
